import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-array',
  components: {},
})
export default class DisplayFieldArray extends mixins(AbstractDisplayField) {
  i = 1;

  valueLabel(value): string {
    const item = this.fieldConfig.valueToLabel?.find(item => item.value === value);
    return item?.label || value;
  }

  get all() {
    if (this.fieldConfig && this.fieldConfig.fieldPath) {
      return this.value.map(a => a[this.fieldConfig.fieldPath]).join(', ');
    }
    return '';
  }
}
